// Signing in bounces through Azure AD and returns to the app without the original
// query string, so harness settings are stashed for the lifetime of the tab. Any
// devtools parameter present in the URL replaces whatever was stored.

const STORAGE_KEY = "borgDevtools";

const DEVTOOLS_PARAMS = ["perf", "record", "tape", "synth", "leaders"];

export function devtoolsParams() {
  const fromUrl = new URLSearchParams(window.location.search);

  if (DEVTOOLS_PARAMS.some((name) => fromUrl.has(name))) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, fromUrl.toString());
    } catch (e) {
      // Private browsing or storage disabled; fall back to URL-only behaviour.
    }
    return fromUrl;
  }

  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    if (stored) return new URLSearchParams(stored);
  } catch (e) {
    // As above.
  }

  return fromUrl;
}

export function clearDevtools() {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // Nothing useful to do if storage is unavailable.
  }
}

if (typeof window !== "undefined") {
  window.clearDevtools = clearDevtools;
}
